import { cmsConfig } from './cms/config'

const config = {
  productRecoSkus: [
    'SAT-BOX-002-000',
    'SAT-TBO-001-800',
    'SAT-RAC-001-9G2',
    'SAT-SPO-001-9SB',
    '00894-90183-10',
    'SAT-HAP-001-803',
    '00253-90216-10',
    'SAT-RAC-001-9G1',
  ],
  cartProductRecoIds: [
    'schlamperbox-purple-laser',
    'trinkflasche-blau',
    'brotdose-mint',
    'sportbeutel-deep-petrol',
    'heftebox-transparent',
  ],
  crossbrand: {
    affenzahn: {
      url: 'https://www.affenzahn.com',
    },
    alvi: {
      url: 'https://www.alvi.de',
    },
    ergobag: {
      url: 'https://www.ergobag.com',
    },
    utmParamsHeader:
      '?utm_source=satch&utm_medium=brand-crosselling&utm_campaign=navigation-meta',
    utmParamsFooter:
      '?utm_source=satch&utm_medium=brand-crosselling&utm_campaign=crossbrand-footer',
  },
  socials: [
    {
      name: 'facebook',
      url: 'https://www.facebook.com/satch.backpack/',
    } as const,
    {
      name: 'instagram',
      url: 'https://www.instagram.com/satch_official/',
    } as const,
  ],
  pagination: {
    itemsPerPage: 24,
    firstPage: 1,
  },
  filterBlacklist: [
    'category',
    'color_1',
    'model',
    'style',
    'model_key',
    'size',
  ],
  matchingModelKeys: [
    'pack_backpack',
    'match_backpack',
    'sleek_backpack',
    'air_backpack',
  ],
  cms: {
    ...cmsConfig,
  },
  locales: [
    {
      code: 'de',
      path: '/de-de/',
    } as const,
    {
      code: 'en',
      path: '/en-eu/',
    } as const,
    {
      code: 'fr',
      path: '/fr-fr/',
    } as const,
    {
      code: 'it',
      path: '/it-it/',
    } as const,
    {
      code: 'da',
      path: '/da-dk/',
    } as const,
    {
      code: 'es',
      path: '/es-es/',
    } as const,
  ],
  productDetailMediaOrder: {
    backpack: {
      productMediaPerspectives: [
        'imgSetComposing',
        'imgFront',
        'video_01',
        'imgModel_01',
        'imgModel_02',
        'imgModel_03',
        'imgModel_04',
        'imgFrontRight',
        'imgRight',
        'imgBack',
        'imgLeft',
        'imgFrontLeft',
        'imgDetail_01',
        'imgDetail_02',
        'imgDetail_03',
        'imgDetail_04',
        'imgDetail_05',
        'imgDetail_06',
        'imgDetail_07',
        'imgDetail_08',
        'imgDetail_09',
        'imgDetail_10',
      ],
    },
    accessories: {
      productMediaPerspectives: [
        'imgFront',
        'imgFrontLeft',
        'imgBack',
        'imgModel_01',
        'imgModel_02',
        'imgModel_03',
        'imgDetail_01',
        'imgDetail_02',
        'imgDetail_03',
        'imgDetail_04',
        'imgDetail_05',
        'imgDetail_06',
      ],
    },
    default: {
      productMediaPerspectives: [
        'imgDetail_04',
        'imgDetail_05',
        'imgDetail_06',
        'imgDetail_07',
        'imgDetail_08',
        'imgDetail_09',
        'imgDetail_10',
      ],
    },
    additional_de: {
      productMediaPerspectives: ['imgUsp_01', 'imgUsp_02'],
    },
  } as const,
  units: {
    weightShort: 'g',
    lengthShort: 'cm',
  } as const,
  account: {
    selfService: {
      maxReturnDays: 30,
      maxVisibleReturnDays: 25,
      customerSupport: {
        tel: '+49 221 956 73 229',
        whatsApp: {
          tel: '+49 157 3599 0819',
          link: 'https://wa.me/4915735990819',
        },
        url: 'https://www.satch.de/kontakt/',
      },
    },
  } as const,
  recommendation: {
    lastSeen: 'e3542b7cdc0e5ceb4ace96e4f7fa260b',
    swaps: '5212057fe229fd1d661e62217ba62660',
    tags: 'c431797a1d89f702190141f63dfcfe4f',
  },
}

export default config
